import DefaultCourseImage from "../../../assest/images/brand/barandeh-saz.png";

export const DEFAULT_COURSE_IMAGE = DefaultCourseImage;

export function resolveCourseMediaUrl(path?: string | null): string {
    if (path == null || path.trim() === "") {
        return DEFAULT_COURSE_IMAGE;
    }

    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }

    return `https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${path}`;
}

export function resolveCourseFileUrl(path?: string | null): string | null {
    if (path == null || path.trim() === "") {
        return null;
    }

    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }

    return `https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${path}`;
}
